import { Reveal, Eyebrow } from "./Reveal";
import { Truck, Building2, Route } from "lucide-react";

const POINTS = [
  { icon: Truck, title: "Armored Transport", text: "Bonded, insured carriers with dual-custody protocols on every movement." },
  { icon: Building2, title: "Zurich · London · Singapore", text: "Recognized vaulting across three Tier-1 storage jurisdictions." },
  { icon: Route, title: "Supply-Chain Integrity", text: "Mine-gate to vault documentation with no unverified custody gaps." },
];

export const Logistics = () => (
  <section id="logistics" data-testid="logistics-section" className="relative py-28 lg:py-36 overflow-hidden">
    <div className="absolute inset-0">
      <img
        src="/assets/mining-truck.webp"
        alt="Heavy mining truck hauling ore at dusk"
        className="w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-[#0A0A0B]/82" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0B] via-[#0A0A0B]/60 to-transparent" />
    </div>

    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="max-w-2xl">
        <Eyebrow>Infrastructure & Logistics</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium tracking-wide text-white leading-snug">
          From pit face to vault door, <span className="gold-text">custody never leaves the record.</span>
        </h2>
        <p className="mt-6 text-base text-zinc-400 leading-relaxed">
          Physical supply is only real if it can move — securely, insured, and
          documented. Our logistics network spans producing regions and the
          vaults where institutions actually hold metal.
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-3 gap-px bg-[#C9A227]/15 card-line max-w-5xl">
        {POINTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1}>
            <div data-testid={`logistics-point-${i}`} className="bg-[#0A0A0B]/90 backdrop-blur-md p-8 h-full hover:bg-[#16161A] transition-colors">
              <p.icon size={20} className="text-[#C9A227] mb-5" />
              <h3 className="font-display text-base text-[#E8C85A] tracking-wide">{p.title}</h3>
              <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
